//*************************DO NOT MODIFY*************************************
//
//THESE FILES ARE AUTOGENERATED AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//
//*************************DO NOT MODIFY*************************************



export interface IBaseTemplateModel {
    uniqueId?: string | null;
    displayName?: string | null;
    referenceName?: string | null;
}

export class BaseTemplateModel implements IBaseTemplateModel {
    public uniqueId: string | null;
    public displayName: string | null;
    public referenceName?: string | null;
}
